var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Togo',{attrs:{"pickupfilter":"ALL","foodType":"AllShops"}}),_c('Footer',{attrs:{"msg":"Footer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }